import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCashDetail = async (params: object) => {
  return await GET({
    url: Api.getCashDetail,
    params: {
      ...params
    },
    showError: false
  })
}
